import { jsxs, jsx } from "react/jsx-runtime";
import { useClassNameFactory } from "@contember/react-utils";
import { memo, forwardRef } from "react";
import { toViewClass } from "../../utils/toViewClass.js";
import { Icon } from "../Icon/Icon.js";
const EditorToolbarButton = memo(forwardRef(({
  label,
  title,
  contemberIcon,
  customIcon,
  blueprintIcon,
  showLabel,
  isActive,
  layout = "grid",
  onClick,
  onMouseDown
}, ref) => {
  const componentClassName = useClassNameFactory("editorToolbarButton");
  return /* @__PURE__ */ jsxs(
    "button",
    {
      ref,
      role: "button",
      type: "button",
      tabIndex: 0,
      onMouseDown,
      onClick,
      title: title || String(label),
      className: componentClassName(null, [
        toViewClass("showLabel", showLabel),
        toViewClass("active", isActive),
        toViewClass(`layout-${layout}`, true)
      ]),
      children: [
        /* @__PURE__ */ jsx("span", { className: componentClassName("icon"), children: /* @__PURE__ */ jsx(Icon, { size: "large", ...{ contemberIcon, customIcon, blueprintIcon } }) }),
        /* @__PURE__ */ jsx("span", { className: componentClassName("label"), children: label })
      ]
    }
  );
}));
EditorToolbarButton.displayName = "EditorToolbarButton";
export {
  EditorToolbarButton
};
//# sourceMappingURL=EditorToolbarButton.js.map
